module.exports = __webpack_public_path__ + "static/img/18.e568d95.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/12/4/1/18.png
// module id = jWuS
// module chunks = 2